import { defineStore } from 'pinia'
import { api } from '@/services/api'
import type { Catalogs } from '@/types/api'
import { activeLocale } from '@/i18n'

export const useCatalogStore = defineStore('catalogs', {
  state: () => ({ data: null as Catalogs | null, loading: false, locale: '', requestVersion: 0 }),
  actions: {
    async load() {
      const locale = activeLocale.value
      if (this.locale === locale && (this.data || this.loading)) return
      const version = ++this.requestVersion
      this.locale = locale; this.loading = true
      try {
        const data = await api<Catalogs>('/api/catalogs')
        if (version === this.requestVersion && locale === activeLocale.value) this.data = data
      } catch (error) { if (version === this.requestVersion) this.locale = ''; throw error }
      finally { if (version === this.requestVersion) this.loading = false }
    }
  }
})
